// AUTO-GENERATED by shared/generators/entity_urls_generator.py — do not edit by hand.
// Source: shared/config/modules_entities.config.json

/** Maps dotted entity type ("module.entity") to its common.json i18n pluralKey.
 * Use with `t(key)` (namespace: common) to get the correct plural display name.
 */
export const ENTITY_PLURAL_KEY_REGISTRY: Record<string, string> = {
  "accounting.account": "entities.accounts",
  "accounting.accounting_audit_log": "entities.accountingAuditLogs",
  "accounting.accounting_document": "entities.accountingDocuments",
  "accounting.bank_account": "entities.bankAccounts",
  "accounting.bank_deposit": "entities.bankDeposits",
  "accounting.bank_deposit_line": "entities.bankDepositLines",
  "accounting.bank_transfer": "entities.bankTransfers",
  "accounting.bill": "entities.bills",
  "accounting.bill_line": "entities.billLines",
  "accounting.claim": "entities.claims",
  "accounting.currency": "entities.currencies",
  "accounting.exchange_rate": "entities.exchangeRates",
  "accounting.finance_charge_run": "entities.financeChargeRuns",
  "accounting.fiscal_period": "entities.fiscalPeriods",
  "accounting.form_filing": "entities.formFilings",
  "accounting.invoice": "entities.invoices",
  "accounting.invoice_line": "entities.invoiceLines",
  "accounting.journal_entry": "entities.journalEntries",
  "accounting.journal_entry_line": "entities.journalEntryLines",
  "accounting.payment": "entities.payments",
  "accounting.payment_allocation": "entities.paymentAllocations",
  "accounting.payment_run": "entities.paymentRuns",
  "accounting.payment_run_bill": "entities.paymentRunBills",
  "accounting.recurring_template": "entities.recurringTemplates",
  "accounting.tax_rate": "entities.taxRates",
  "accounting.tax_rate_component": "entities.taxRateComponents",
  "accounting.vendor_classification_rule": "entities.vendorClassificationRules",
  "accounting.vendor_payment_method": "entities.vendorPaymentMethods",
  "accounting.vendor_statement": "entities.vendorStatements",
  "accounting.vendor_statement_line": "entities.vendorStatementLines",
  "ai_agents.agent": "entities.agents",
  "ai_agents.agent_chat": "entities.agentChats",
  "ai_agents.agent_context_file": "entities.contextFiles",
  "ai_agents.agent_pending_approval": "entities.agentApprovals",
  "ai_chat.chat": "entities.chats",
  "ai_chat.chat_message": "entities.chatMessages",
  "avatars.avatar_session": "entities.avatarSessions",
  "billing.billing_account": "entities.billingAccounts",
  "billing.billing_dispute": "entities.billingDisputes",
  "billing.billing_tier": "entities.billingTiers",
  "billing.billing_wallet": "entities.billingWallets",
  "billing.billing_wallet_ledger": "entities.billingLedgerEntries",
  "brokerage.bkr_aggregation": "entities.brokerageAggregations",
  "brokerage.bkr_bid": "entities.brokerageBids",
  "brokerage.bkr_downstream_distribution": "entities.brokerageDownstreamDistributions",
  "brokerage.bkr_logistics_destination": "entities.brokerageLogisticsDestinations",
  "brokerage.bkr_offer_sheet": "entities.brokerageOfferSheets",
  "brokerage.bkr_offer_sheet_item": "entities.brokerageOfferSheetItems",
  "chatbot.chatbot_bot": "entities.chatbotBots",
  "chatbot.chatbot_channel": "entities.chatbotChannels",
  "chatbot.chatbot_conversation": "entities.chatbotConversations",
  "chatbot.chatbot_flow": "entities.chatbotFlows",
  "chatbot.chatbot_message": "entities.chatbotMessages",
  "coding.coding_task": "entities.codingTasks",
  "contracts.approval": "entities.approvals",
  "contracts.contract": "entities.contracts",
  "contracts.contract_clause": "entities.contractClauses",
  "contracts.contract_party": "entities.contractParties",
  "contracts.contract_playbook": "entities.contractPlaybooks",
  "contracts.contract_playbook_rule": "entities.contractPlaybookRules",
  "contracts.contract_template": "entities.contractTemplates",
  "contracts.contract_type": "entities.contractTypes",
  "contracts.contract_version": "entities.contractVersions",
  "contracts.counterparty_request": "entities.counterpartyRequests",
  "contracts.obligation": "entities.obligations",
  "contracts.signature": "entities.signatures",
  "developer.api_key": "entities.apiKeys",
  "developer.api_usage": "entities.apiUsages",
  "email.email_routing_rule": "entities.emailRoutingRules",
  "email.email_sender_whitelist": "entities.emailSenderWhitelists",
  "email.email_template": "entities.emailTemplates",
  "email.inbound_email": "entities.inboundEmails",
  "email.user_email_address": "entities.userEmailAddresses",
  "file_management.file": "entities.files",
  "file_management.folder": "entities.folders",
  "forms_bpm.fbpm_business_process": "entities.businessProcesses",
  "forms_bpm.fbpm_form": "entities.forms",
  "forms_bpm.fbpm_form_submission": "entities.formSubmissions",
  "forms_bpm.fbpm_process_instance": "entities.processInstances",
  "forms_bpm.fbpm_review": "entities.reviews",
  "forms_bpm.fbpm_scorecard": "entities.scorecards",
  "inventory.location": "entities.locations",
  "inventory.stock_adjustment": "entities.stockAdjustments",
  "inventory.stock_issue": "entities.issueStock",
  "inventory.stock_level": "entities.stockLevels",
  "inventory.stock_lot": "entities.stockLots",
  "inventory.stock_receipt": "entities.receiveStock",
  "inventory.stock_take": "entities.stockTakes",
  "inventory.stock_transfer": "entities.stockTransfers",
  "inventory.warehouse": "entities.warehouses",
  "marketing.newsletter": "entities.newsletters",
  "marketing.newsletter_issue": "entities.newsletterIssues",
  "marketing.newsletter_subscription": "entities.newsletterSubscriptions",
  "marketing.newsletter_template": "entities.newsletterTemplates",
  "master_data.address": "entities.addresses",
  "master_data.bundle_item": "entities.bundleItems",
  "master_data.company": "entities.companies",
  "master_data.company_visibility": "entities.companyVisibilities",
  "master_data.contact": "entities.contacts",
  "master_data.contact_visibility": "entities.contactVisibilities",
  "master_data.interaction": "entities.interactions",
  "master_data.offering": "entities.offerings",
  "master_data.price_list": "entities.priceLists",
  "master_data.price_list_entry": "entities.priceListEntries",
  "master_data.pricing_campaign": "entities.pricingCampaigns",
  "master_data.product": "entities.products",
  "master_data.product_addon": "entities.productAddons",
  "master_data.product_category": "entities.productCategories",
  "master_data.product_configuration": "entities.productConfigurations",
  "master_data.product_configuration_value": "entities.productConfigurationValues",
  "master_data.product_packaging": "entities.packagingUnits",
  "master_data.product_variant": "entities.productVariants",
  "master_data.tier": "entities.tiers",
  "master_data.usage_metric": "entities.usageMetrics",
  "master_data.usage_price_tier": "entities.usagePriceTiers",
  "messaging.messaging_conversation": "entities.conversations",
  "messaging.messaging_message": "entities.messages",
  "messaging.messaging_reminder": "entities.reminders",
  "people.people_employee": "entities.employees",
  "people.people_employee_compensation": "entities.compensations",
  "people.people_employee_contact": "entities.employeeContacts",
  "people.people_employee_job": "entities.employeeJobs",
  "people.people_employee_skill": "entities.employeeSkills",
  "people.people_goal": "entities.goals",
  "people.people_job_title": "entities.jobTitles",
  "people.people_leave_balance": "entities.leaveBalances",
  "people.people_leave_policy": "entities.leavePolicies",
  "people.people_leave_request": "entities.leaveRequests",
  "people.people_onboarding_instance": "entities.onboardingInstances",
  "people.people_onboarding_task": "entities.onboardingTasks",
  "people.people_onboarding_template": "entities.onboardingTemplates",
  "people.people_one_on_one": "entities.oneOnOnes",
  "people.people_recognition": "entities.recognitions",
  "people.people_report_definition": "entities.peopleReports",
  "people.people_review": "entities.reviews",
  "people.people_review_cycle": "entities.reviewCycles",
  "people.people_survey": "entities.surveys",
  "people.people_survey_wave": "entities.surveyWaves",
  "pipeline.pipeline_deal": "entities.deals",
  "pipeline.pipeline_deal_contact": "entities.dealContacts",
  "pipeline.pipeline_deal_stage_history": "entities.dealStageHistories",
  "pipeline.pipeline_email_template": "entities.emailTemplates",
  "pipeline.pipeline_outreach_task": "entities.outreachTasks",
  "pipeline.pipeline_pipeline": "entities.pipelines",
  "pipeline.pipeline_sequence": "entities.sequences",
  "pipeline.pipeline_sequence_step": "entities.sequenceSteps",
  "pipeline.pipeline_stage": "entities.stages",
  "procurement.goods_receipt": "entities.goodsReceipts",
  "procurement.purchase_order": "entities.purchaseOrders",
  "procurement.purchase_requisition": "entities.purchaseRequisitions",
  "procurement.recurring_po_template": "entities.recurringPoTemplates",
  "procurement.rfq": "entities.rfqs",
  "procurement.supplier_claim": "entities.supplierClaims",
  "procurement.supplier_pi": "entities.supplierPis",
  "procurement.vendor_profile": "entities.vendorProfiles",
  "procurement.vendor_return": "entities.vendorReturns",
  "recruiting.recruiting_activity": "entities.activities",
  "recruiting.recruiting_application": "entities.applications",
  "recruiting.recruiting_application_question": "entities.applicationQuestions",
  "recruiting.recruiting_application_stage_history": "entities.applicationStageHistories",
  "recruiting.recruiting_candidate": "entities.candidates",
  "recruiting.recruiting_department": "entities.departments",
  "recruiting.recruiting_email_template": "entities.emailTemplates",
  "recruiting.recruiting_interview": "entities.interviews",
  "recruiting.recruiting_interview_feedback": "entities.interviewFeedbacks",
  "recruiting.recruiting_interview_participant": "entities.interviewParticipants",
  "recruiting.recruiting_job_board_posting": "entities.jobBoardPostings",
  "recruiting.recruiting_job_interviewer": "entities.interviewers",
  "recruiting.recruiting_job_posting": "entities.jobs",
  "recruiting.recruiting_pipeline": "entities.pipelines",
  "recruiting.recruiting_rejection_reason": "entities.rejectionReasons",
  "recruiting.recruiting_scorecard_template": "entities.scorecardTemplates",
  "recruiting.recruiting_stage": "entities.stages",
  "sales.sales_channel": "entities.salesChannels",
  "sales.sales_commission_payout_run": "entities.salesCommissionPayoutRuns",
  "sales.sales_commission_plan": "entities.salesCommissionPlans",
  "sales.sales_customer_account": "entities.salesCustomerAccounts",
  "sales.sales_delivery": "entities.salesDeliveries",
  "sales.sales_order": "entities.salesOrders",
  "sales.sales_order_item": "entities.salesOrderItems",
  "sales.sales_order_type": "entities.salesOrderTypes",
  "sales.sales_partner": "entities.salesPartners",
  "sales.sales_return": "entities.salesReturns",
  "shared.audit_log": "entities.auditLogs",
  "shared.session": "entities.sessions",
  "shared.tenant": "entities.tenants",
  "shipments.airline": "entities.airlines",
  "shipments.cfs_receipt": "entities.cfsReceipts",
  "shipments.consol": "entities.consols",
  "shipments.customs_entry": "entities.customsEntries",
  "shipments.freetime_term": "entities.freetimeTerms",
  "shipments.freight_agent": "entities.freightAgents",
  "shipments.freight_settlement_run": "entities.freightSettlementRuns",
  "shipments.load_unit_type": "entities.loadUnitTypes",
  "shipments.ocean_carrier": "entities.oceanCarriers",
  "shipments.port_location": "entities.portLocations",
  "shipments.shipment": "entities.shipments",
  "shipments.shipment_document": "entities.shipmentDocuments",
  "shipments.shipment_estimate": "entities.shipmentEstimates",
  "software_factory.sf_changelog_entry": "entities.sfChangelogEntries",
  "software_factory.sf_exception_fingerprint": "entities.sfExceptionFingerprints",
  "software_factory.sf_initiative": "entities.sfInitiatives",
  "software_factory.sf_milestone": "entities.milestones",
  "software_factory.sf_module": "entities.sfModules",
  "software_factory.sf_sprint": "entities.sfSprints",
  "software_factory.sf_user_announcement": "entities.userAnnouncements",
  "software_factory.sf_work_item": "entities.sfWorkItems",
  "support.support_agent_config": "entities.agentConfigs",
  "support.support_business_hours": "entities.businessHours",
  "support.support_canned_response": "entities.cannedResponses",
  "support.support_kb_article": "entities.kbArticles",
  "support.support_kb_category": "entities.kbCategories",
  "support.support_routing_rule": "entities.routingRules",
  "support.support_sla_escalation_rule": "entities.slaEscalationRules",
  "support.support_sla_policy": "entities.slaPolicies",
  "support.support_ticket": "entities.supportTickets",
  "support.support_ticket_attachment": "entities.ticketAttachments",
  "support.support_ticket_message": "entities.ticketMessages",
  "sysadmin.alert": "entities.alerts",
  "tasks.board": "entities.boards",
  "tasks.board_column": "entities.boardColumns",
  "tasks.board_member": "entities.boardMembers",
  "tasks.board_view": "entities.boardViews",
  "tasks.sprint": "entities.sprints",
  "tasks.sprint_scope_change": "entities.sprintScopeChanges",
  "tasks.task": "entities.tasks",
  "tasks.task_assignee": "entities.assignees",
  "tasks.task_checklist_item": "entities.checklistItems",
  "tasks.task_column_value": "entities.columnValues",
  "tasks.task_group": "entities.taskGroups",
  "tasks.task_link": "entities.taskLinks",
  "tasks.task_watcher": "entities.watchers",
  "tasks.workspace": "entities.workspaces",
  "tasks.workspace_member": "entities.workspaceMembers",
  "third_party_services.integration_credential": "entities.integrationCredentials",
  "third_party_services.user_oauth_connection": "entities.oauthConnections",
  "user_management.company": "entities.companies",
  "user_management.email_verification_token": "entities.emailVerificationTokens",
  "user_management.join_request": "entities.joinRequests",
  "user_management.office": "entities.offices",
  "user_management.password_reset_token": "entities.passwordResetTokens",
  "user_management.user": "entities.users",
  "user_management.user_group": "entities.groups",
  "user_management.user_group_membership": "entities.groupMemberships",
  "website_hosting.website": "entities.websites",
  "website_hosting.website_asset": "entities.websiteAssets",
  "website_hosting.website_deployment": "entities.websiteDeployments",
  "website_hosting.website_domain": "entities.websiteDomains",
  "website_hosting.website_page": "entities.websitePages",
};
